export default __webpack_public_path__ + "static/media/codesnippet3.2261cf93.png";